import { defer, type Observable, tap } from 'rxjs'
import type { GetLocationFn } from '@/RootStore'
import type { NavigateFn } from '@/RootStore'
import { Id } from '@/infra/id'
import { links } from '@/utils/link'
import { type Member } from '@/features/iam/members/Member'

/**
 * Returns to the path last visited in a workspace when switching back to it.
 *
 * @param currentMember$
 * @param navigate
 * @param getLocation
 */
export function workspacePathRestore(
  currentMember$: Observable<Member>,
  navigate: NavigateFn,
  getLocation: GetLocationFn,
) {
  return defer(() => {
    const lastPaths = new Map<string, string>()
    let currentWorkspaceId: string | null = null

    return currentMember$.pipe(
      tap((member) => {
        if (currentWorkspaceId !== null) {
          lastPaths.set(currentWorkspaceId, getLocation().pathname)
        }
        const workspaceId = Id.assert(member.workspace.id)
        currentWorkspaceId = workspaceId
        const lastPath = lastPaths.get(workspaceId) ?? ''
        lastPaths.set(workspaceId, lastPath)
        // The first workspace of the session keeps the URL it was opened with.
        if (lastPaths.size > 1) {
          navigate(lastPath || links.welcome(), { replace: true })
        }
      }),
    )
  })
}
